import * as analyticsModule from '../analytics';
import { handleEmployeeSizeChange, showParternshipTeamCalendar } from './hubspot';
import { downloadPdfFile } from '../common';
import { getIPAddress } from '../utils/analytics';
import {integrationUrls} from './variables';
import { showModal, hideModal, hideModals, showCalendarModalForUS } from '../utility';

/* global sendGaEvents */

// Opens the primary demo form modal and sends a GA event.
export const openPrimaryDemoForm = () => {
  showModal('primary-demo-form-modal');
  window.sendGaEvents('click-modal', 'schedule-demo', 'body');
};

// Attaches an event listener that listens for clicks on elements matching the provided selector.
export const handleFileDownloadClick = (selector) => {
  document.addEventListener('click', (event) => {
    const target = event.target.closest(selector);
    if (!target) {
      return;
    }

    const fileUrl = target.getAttribute('data-file');
    const fileName = target.textContent;

    document.querySelector('.last-download-url').value = fileUrl;
    document.querySelector('.last-download-name').value = fileName;
    document.querySelector('#report-heading').textContent = fileName;
  });
};

// Creates a key-value object from the given fields and saves each value to localStorage.
export const getContactDetails = (fields) =>
  fields.reduce((acc, { name, value }) => {
    acc[name] = value;
    localStorage.setItem(name, value);
    return acc;
  }, {});

// Handles Contact / Demo / Partnership Forms
const handleContactForms = (context, ipInfo, contactUsTyModal) => {
  let contactPurpose = 'demo';

  if (context.formDataFields.contact_purpose_updated === 'partner') {
    context.thankyouform.successMessage = context.formSuccessMessages.partnerReferralMessage;
    contactPurpose = 'partners';
  } else if (context.formDataFields.contact_purpose_updated === 'cocpa') {
    context.thankyouform.successMessage = context.formSuccessMessages.cocpaFormSuccessMessage;
    contactPurpose = 'cocpa';
  } else if (context.formDataFields.contact_purpose_updated === 'I want to talk about partnerships') {
    context.thankyouform.successMessage = context.formSuccessMessages.partnerReferralMessage;
    context.thankyouform.successMessageTitle = context.formSuccessMessages.partnerReferralTitle;
    contactPurpose = 'I want to talk about partnerships';
  } else {
    context.thankyouform.successMessage = context.formSuccessMessages.demoFormSuccessMessage;
  }

  context.thankyouform.demoFormThankYouImage = true;
  context.thankyouform.thankYouImage = false;
  context.thankyouform.sendFeedbackThankYouImage = false;

  // Hide modals to prevent UI jitter
  setTimeout(() => {
    hideModals(['contact-us-modal', 'all-feature-modal', 'demo-offer-modal', 'partner-form-modal']);

    const bgVideo = document.querySelector('.bgVideo');
    const allFeatureModal = document.getElementById('all-feature-modal');
    
    // Check if modal is actually visible (equivalent to jQuery's :visible)
    const isModalVisible = allFeatureModal &&
      allFeatureModal.offsetParent !== null &&
      getComputedStyle(allFeatureModal).display !== 'none' &&
      getComputedStyle(allFeatureModal).visibility !== 'hidden';
      
    if (bgVideo && !isModalVisible) {
      setTimeout(() => {
        bgVideo.style.display = 'none';
      }, 4500);
    }
  }, 200);

  if (contactPurpose === 'demo') {
    hideModal('primary-demo-form-modal');
    const employeeElement = document.getElementById('number_of_employees');
    const initialSize = employeeElement ? employeeElement.value : '';
    
    const showCalendarModal = showCalendarModalForUS(ipInfo);
    if (showCalendarModal) {
      handleEmployeeSizeChange(initialSize);
      showCalendarModal();
    } else {
      showModal(contactUsTyModal);
    }
  } else if (contactPurpose === 'cocpa') {
    hideModal('primary-demo-form-modal--cocpa');
    
    const showCalendarModal = showCalendarModalForUS(ipInfo);
    if (showCalendarModal) {
      showParternshipTeamCalendar();
      showCalendarModal();
    } else {
      showModal(contactUsTyModal);
    }
  } else {
    hideModals(['primary-demo-form-modal--cocpa', 'primary-demo-form-modal--accounting-firms']);
    showModal(contactUsTyModal);
  }

  analyticsModule.addCapterraScript();
  sendGaEvents('form-contact', contactPurpose, 'form-1', true);
};

// Handles Content Download Forms (without demo)
const handleContentDownloadForms = (context) => {
  const {
    email: userEmailID,
    content_access_type: contentAccessType,
    last_download_url: contentDownloadURL,
  } = context.formDataFields;

  const webinarHeaderElement = document.getElementById('webinar-header');
  const reportHeadingElement = document.getElementById('report-heading');
  
  const webinarHeader = webinarHeaderElement ? webinarHeaderElement.textContent : '';
  const reportHeading = reportHeadingElement ? reportHeadingElement.textContent : '';
  const webinarTitle = webinarHeader.length > 0 ? webinarHeader : reportHeading;

  // Extract resource type ID matching original jQuery behavior
  // $('.webinar-case-study-hero, .card-deck').children('div').attr('id')
  let resourceTypeId = '';
  const parentElements = document.querySelectorAll('.webinar-case-study-hero, .card-deck');
  
  // Collect all direct div children from all parent elements (mimicking jQuery behavior)
  const allDivChildren = [];
  parentElements.forEach((parent) => {
    const divChildren = parent.querySelectorAll(':scope > div');
    allDivChildren.push(...divChildren);
  });
  
  // Return the ID of the first div child, or empty string if it doesn't have an ID
  if (allDivChildren.length > 0) {
    resourceTypeId = allDivChildren[0].id || '';
  }

  // Build URL parameters for redirection
  const queryParams = new URLSearchParams({
    email: userEmailID,
    title: webinarTitle,
    content: contentAccessType,
    link: contentDownloadURL,
    rtype: resourceTypeId,
  });

  sendGaEvents('form-content', contentAccessType, webinarTitle, false);
  window.location.href = `/thank-you?${queryParams.toString()}`;
};

// Handles Content Download Form with Demo
const handleContentDownloadWithDemo = (context) => {
  const currentPath = context.currentPathName;
  const downloadUrl = integrationUrls[currentPath];

  if (downloadUrl) {
    const titlePrefix = 'Fyle';
    const lastPartOfUrl = currentPath.split('/').pop();
    const [firstWord] = lastPartOfUrl.split('-');
    const title = `${titlePrefix}-${firstWord.charAt(0).toUpperCase()}${firstWord.slice(1)}-Integration`;
    downloadPdfFile(title, downloadUrl);
  }
  hideModal('contact-us-modal-demo-content-form');
};

// Handles Feedback Form
const handleFeedbackForm = (context, contactUsTyModal) => {
  context.chromeFeedbackSuccess = true;
  context.thankyouform.thankYouImage = false;
  context.thankyouform.demoFormThankYouImage = false;
  context.thankyouform.sendFeedbackThankYouImage = true;
  context.thankyouform.successMessageTitle = context.formSuccessMessages.sendFeedBack;
  context.thankyouform.successMessage = '';
  showModal(contactUsTyModal);
};

// Handles Feature Download Form
const handleFeatureDownloadForm = (context, contactUsTyModal) => {
  if (context.currentPathName === '/idc-marketscape-innovator-2020') {
    context.thankyouform.successMessage = context.formSuccessMessages.idcMessage;
    sendGaEvents('form-idc', 'download', 'idc-report', false);
  } else {
    context.thankyouform.successMessage = context.formSuccessMessages.downloadFeatureMessage;
    if (context.currentPathName === '/pricing') {
      sendGaEvents('form-content', 'download-features', 'pricing', false);
    } else if (context.currentPathName === '/product') {
      sendGaEvents('form-content', 'download-features', 'product', false);
    }
  }
  context.thankyouform.thankYouImage = true;
  showModal(contactUsTyModal);
  hideModal('all-feature-modal');
};

// Handles Exit-Intent Modal Form
const handleExitIntentForm = (context, ipInfo, contactUsTyModal) => {
  hideModal('demo-offer-modal');
  
  const showCalendarModal = showCalendarModalForUS(ipInfo);
  if (showCalendarModal) {
    const exitIntentModal = document.getElementById('contact-us-form-exit-intent-modal');
    const employeeElement = exitIntentModal ? exitIntentModal.querySelector('#number_of_employees') : null;
    const initialSize = employeeElement ? employeeElement.value : '';
    
    handleEmployeeSizeChange(initialSize);
    showCalendarModal();
  } else {
    context.thankyouform.successMessage = context.formSuccessMessages.exitIntentDemoFormSuccessMessage;
    context.thankyouform.thumbsUpImage = true;
    context.thankyouform.thankYouImage = false;
    showModal(contactUsTyModal);
  }
  sendGaEvents('form-contact', 'demo', 'form-1', true);
};

// Handles Baker Tilly Webinar Registration Form
const handleBakerTillyWebinarForm = (context, contactUsTyModal) => {
  context.thankyouform.successMessage = context.formSuccessMessages.bakerTillyWebinarFormSuccessMessage;
  context.thankyouform.successMessageTitle = context.formSuccessMessages.bakerTillyWebinarFormSuccessMessageTitle;
  context.thankyouform.thankYouImage = true;
  showModal(contactUsTyModal);
  sendGaEvents('form-contact', 'Partner_webinar_registrations', 'baker_tilly');
};

// Handles various form submission scenarios.
export const handleFormSubmissionSuccess = (context) => {
  const contactUsTyModal = '#contact-us-ty-modal';

  // Process contact details, update state, and reset form
  context.getContactDetailsWrapper();
  context.setClarityID();
  context.emailError = false;
  context.resetForm();
  sessionStorage.setItem('demoFormSubmitted', 'true');

  // Retrieve IP information for conditional logic
  const ipInfo = getIPAddress();
  const formId = context.formId;

  // Group form IDs for easier management
  const contactFormIds = [
    context.formIdsMap.contactUsForm,
    context.formIdsMap.contactUsFormOutsideModal,
    context.formIdsMap.mncpaForm,
    context.formIdsMap.cocpaForm,
    context.formIdsMap.alabamaForm,
    context.formIdsMap.floridaForm,
    context.formIdsMap.accountingFirmsForm,
    context.formIdsMap.partnerReferralForm,
  ];

  const contentDownloadFormIds = [
    context.formIdsMap.contentDownloadForm,
    context.formIdsMap.contentDownloadFormAllFeatures,
    context.formIdsMap.contentDownloadOutsideModal,
    context.formIdsMap.contentDownloadReportForm,
  ];

  if (contactFormIds.includes(formId)) {
    handleContactForms(context, ipInfo, contactUsTyModal);
  } else if (contentDownloadFormIds.includes(formId)) {
    handleContentDownloadForms(context);
  } else if (formId === context.formIdsMap.contentDownloadFormWithDemo) {
    handleContentDownloadWithDemo(context);
  } else if (formId === context.formIdsMap.sendFeedBack) {
    handleFeedbackForm(context, contactUsTyModal);
  } else if (formId === context.formIdsMap.contactUsFormFeatureDownload) {
    handleFeatureDownloadForm(context, contactUsTyModal);
  } else if (formId === context.formIdsMap.contactUsFormExitIntentModal) {
    handleExitIntentForm(context, ipInfo, contactUsTyModal);
  } else if (formId === context.formIdsMap.bakerTillyWebinarForm) {
    handleBakerTillyWebinarForm(context, contactUsTyModal);
  }
};

// Serializes the form fields into an array of name/value objects.
export const serializeFormFields = (formData) => {
  const serializedFields = [];
  const fields = formData.form;

  Array.from(fields).forEach((item) => {
    // Process the field if it has a name and is either not a radio/checkbox or is checked.
    if (
      (item.name && item.type !== 'radio' && item.type !== 'checkbox') ||
      item.checked !== false
    ) {
      if (item.name !== '') {
        if (item.name === 'firstname') {
          // Split full name into first and last name.
          const [firstName, ...lastNameParts] = item.value.split(' ');
          serializedFields.push({ name: 'firstname', value: firstName });
          serializedFields.push({ name: 'lastname', value: lastNameParts.join(' ') });
        } else if (item.name === 'client_fullname') {
          // Map client_fullname to firstname.
          serializedFields.push({ name: 'firstname', value: item.value });
        } else {
          serializedFields.push({ name: item.name, value: item.value });
        }
      }
    }
  });

  // Extract clarity user id from cookies.
  const clarityMatch = document.cookie.match(new RegExp('(^|;)\\s*_clck=([^;]+)'));
  const clarityUserId = clarityMatch ? clarityMatch[2] : 'Clarity ID not recorded';

  serializedFields.push({ name: 'clarity_user_id', value: clarityUserId });

  return serializedFields;
};
